module.exports = __webpack_public_path__ + "static/media/apps-and-api.b95bdfc4.svg";